import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex md:items-center lg:items-center items-start md:flex-row lg:flex-row flex-col p-4 justify-between" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "mr-2 text-subtitle1 lg:mb-0 md:mb-0 mb-3" }, "Daftar Barang Akan Dikirim", -1)
const _hoisted_3 = {
  key: 0,
  class: "flex items-center flex-wrap background-orange-lighten-5 px-4 py-2 rounded-lg border-dash-orange w-full md:w-auto"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "text-base color-blue-grey font-bold mr-2 mb-2" }, "Voucer Digunakan :", -1)
const _hoisted_5 = { class: "color-primary font-bold mr-2 mb-2" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-times text-xs color-red mr-1" }),
  /*#__PURE__*/_createVNode("span", { class: "color-red text-xs font-bold" }, "Batal")
], -1)
const _hoisted_7 = { class: "form-diskon flex items-center" }
const _hoisted_8 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  focusable: "false",
  width: "1em",
  height: "1em",
  style: {"-ms-transform":"rotate(360deg)","-webkit-transform":"rotate(360deg)","transform":"rotate(360deg)"},
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M21 5H3a1 1 0 0 0-1 1v4h.893c.996 0 1.92.681 2.08 1.664A2.001 2.001 0 0 1 3 14H2v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4h-1a2.001 2.001 0 0 1-1.973-2.336c.16-.983 1.084-1.664 2.08-1.664H22V6a1 1 0 0 0-1-1zM11 17H9v-2h2v2zm0-4H9v-2h2v2zm0-4H9V7h2v2z",
    fill: "#ffffff"
  })
], -1)
const _hoisted_9 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_10 = { class: "text-black font-semibold px-4 h-10 md:h-14 flex items-center" }
const _hoisted_11 = { class: "text-black font-semibold px-4 h-10 md:h-14 flex items-center" }
const _hoisted_12 = { class: "text-black font-semibold px-4 h-10 md:h-14 flex items-center" }
const _hoisted_13 = { class: "text-black font-semibold px-4 h-10 md:h-14 flex items-center" }
const _hoisted_14 = {
  key: 0,
  class: "font-semibold px-4 h-10 md:h-14 text-red-500 flex items-center"
}
const _hoisted_15 = {
  key: 1,
  class: "color-blue-grey-lighten-2 font-semibold px-4 h-10 md:h-14 flex items-center"
}
const _hoisted_16 = { class: "text-black font-semibold px-4 h-10 md:h-14 flex items-center" }
const _hoisted_17 = { class: "flex w-full justify-between items-center px-2" }
const _hoisted_18 = { class: "w-1/2 sm:w-max" }
const _hoisted_19 = {
  key: 0,
  class: "chip-orange gap-2 flex items-center px-3 py-1"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("svg", {
  width: "15",
  height: "10",
  viewBox: "0 0 15 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M13.5007 0.333374H1.50065C1.32384 0.333374 1.15427 0.403612 1.02925 0.528636C0.904222 0.653661 0.833984 0.82323 0.833984 1.00004V3.66671H1.42932C2.09332 3.66671 2.70932 4.12071 2.81598 4.77604C2.84848 4.9674 2.83882 5.16354 2.78769 5.35079C2.73656 5.53803 2.64519 5.71186 2.51995 5.86014C2.3947 6.00843 2.23861 6.12759 2.06256 6.20933C1.88651 6.29106 1.69475 6.3334 1.50065 6.33337H0.833984V9.00004C0.833984 9.17685 0.904222 9.34642 1.02925 9.47145C1.15427 9.59647 1.32384 9.66671 1.50065 9.66671H13.5007C13.6775 9.66671 13.847 9.59647 13.9721 9.47145C14.0971 9.34642 14.1673 9.17685 14.1673 9.00004V6.33337H13.5007C13.3066 6.3334 13.1148 6.29106 12.9387 6.20933C12.7627 6.12759 12.6066 6.00843 12.4814\r\n                  5.86014C12.3561 5.71186 12.2647 5.53803 12.2136 5.35079C12.1625 5.16354 12.1528 4.9674 12.1853 4.77604C12.292 4.12071 12.908 3.66671 13.572 3.66671H14.1673V1.00004C14.1673 0.82323 14.0971 0.653661 13.9721 0.528636C13.847 0.403612 13.6775 0.333374 13.5007 0.333374ZM6.83398 8.33337H5.50065V7.00004H6.83398V8.33337ZM6.83398 5.66671H5.50065V4.33337H6.83398V5.66671ZM6.83398 3.00004H5.50065V1.66671H6.83398V3.00004Z",
    fill: "#FF9800"
  })
], -1)
const _hoisted_21 = { class: "text-sm" }
const _hoisted_22 = { class: "w-1/2 sm:w-max flex items-center" }
const _hoisted_23 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey text-subtitle2" }, "Total:  ", -1)
const _hoisted_24 = { class: "text-black font-bold text-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "card-no-shadow card-p-0 mb-8" }, {
    content: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.voucherIsTrue)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _hoisted_4,
              _createVNode("p", _hoisted_5, _toDisplayString(_ctx.voucherId.toUpperCase()), 1),
              _createVNode(_component_Button, {
                icon: "pi pi-check",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancelVoucher())),
                class: "p-button-sm p-button-outlined p-button-danger mb-2 px-4 py-1 ml-auto",
                style: {"width":"auto !important"}
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]))
          : (!_ctx.voucherIsTrue && !_ctx.isMiisi)
            ? (_openBlock(), _createBlock("form", {
                key: 1,
                id: "form-diskon",
                class: "md:w-auto w-full",
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.submitVoucher()), ["prevent"]))
              }, [
                _createVNode("div", _hoisted_7, [
                  _createVNode(_component_InputText, {
                    id: "voucher",
                    class: "input-primary border-dashed text-sm flex-1 md:flex-0",
                    modelValue: _ctx.voucherId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.voucherId = $event)),
                    placeholder: "Redeem Voucher",
                    type: "text",
                    disabled: _ctx.isMiisi
                  }, null, 8, ["modelValue", "disabled"]),
                  _createVNode(_component_Button, {
                    class: "btn-primary",
                    type: "submit",
                    form: "form-diskon",
                    disabled: _ctx.isMiisi
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ], 32))
            : _createCommentVNode("", true)
      ]),
      _createVNode(_component_DataTable, {
        value: _ctx.listItems,
        class: "table-og table-list-receipt body-td-x-0"
      }, {
        footer: _withCtx(() => [
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, [
              (_ctx.voucherIsTrue)
                ? (_openBlock(), _createBlock("div", _hoisted_19, [
                    _hoisted_20,
                    _createVNode("p", _hoisted_21, "Potongan: " + _toDisplayString(new
          Number(_ctx.$store.state.deliveryItem.voucherAttr.voucherValue).toLocaleString("id-ID")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode("p", _hoisted_24, "Rp. " + _toDisplayString(new Number(_ctx.lodash.sum(_ctx.listItems.map(x => x.TotalHarga)) -
                _ctx.$store.state.deliveryItem.voucherAttr.voucherValue).toLocaleString("id-ID")), 1)
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            header: "Berat",
            style: { width: '10%' }
          }, {
            body: _withCtx((slotProps) => [
              _createVNode("p", _hoisted_9, _toDisplayString(slotProps.data.Berat) + " " + _toDisplayString(slotProps.data.Satuan), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Kategori Barang",
            field: "Jadwal",
            style: { width: '15%' }
          }, {
            body: _withCtx((slotProps) => [
              _createVNode("p", _hoisted_10, _toDisplayString(slotProps.data.KategoriBarang), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Biaya Barang",
            style: { width: '15%' }
          }, {
            body: _withCtx((slotProps) => [
              _createVNode("p", _hoisted_11, "Rp " + _toDisplayString(new
          Number(slotProps.data.Harga).toLocaleString("id-ID")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Biaya Tambahan",
            style: { width: '15%' }
          }, {
            body: _withCtx((slotProps) => [
              _createVNode("p", _hoisted_12, "Rp " + _toDisplayString(new
          Number(slotProps.data.BiayaTambahan).toLocaleString("id-ID")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Asuransi",
            style: { width: '15%' }
          }, {
            body: _withCtx((slotProps) => [
              _createVNode("p", _hoisted_13, _toDisplayString(slotProps.data.NamaAsuransi), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Diskon",
            style: { width: '15%' }
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.DiskonValue)
                ? (_openBlock(), _createBlock("p", _hoisted_14, " - Rp. " + _toDisplayString(new Number(slotProps.data.DiskonValue).toLocaleString("id-ID")), 1))
                : (_openBlock(), _createBlock("p", _hoisted_15, " 0"))
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Sub Total",
            style: {"width":"15%"}
          }, {
            body: _withCtx((slotProps) => [
              _createVNode("p", _hoisted_16, "Rp. " + _toDisplayString(new
          Number(slotProps.data.TotalHarga - (slotProps.data.DiskonValue ? slotProps.data.DiskonValue :
            0)).toLocaleString("id-ID")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _: 1
  }))
}